/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiProductTaggerUniqueFieldFromJSON, ApiProductTaggerUniqueFieldToJSON, } from './ApiProductTaggerUniqueField';
export function ApiProductTaggerSimplifiedFromJSON(json) {
    return ApiProductTaggerSimplifiedFromJSONTyped(json, false);
}
export function ApiProductTaggerSimplifiedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'brandSelector': !exists(json, 'brandSelector') ? undefined : json['brandSelector'],
        'categorySelector': !exists(json, 'categorySelector') ? undefined : json['categorySelector'],
        'descriptionSelector': !exists(json, 'descriptionSelector') ? undefined : json['descriptionSelector'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'imageUrlSelector': !exists(json, 'imageUrlSelector') ? undefined : json['imageUrlSelector'],
        'locationId': !exists(json, 'locationId') ? undefined : json['locationId'],
        'priceSelector': !exists(json, 'priceSelector') ? undefined : json['priceSelector'],
        'productIdSelector': !exists(json, 'productIdSelector') ? undefined : json['productIdSelector'],
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'skuSelector': !exists(json, 'skuSelector') ? undefined : json['skuSelector'],
        'titleSelector': !exists(json, 'titleSelector') ? undefined : json['titleSelector'],
        'uniqueField': !exists(json, 'uniqueField') ? undefined : ApiProductTaggerUniqueFieldFromJSON(json['uniqueField']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'useLinkedData': !exists(json, 'useLinkedData') ? undefined : json['useLinkedData'],
    };
}
export function ApiProductTaggerSimplifiedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'brandSelector': value.brandSelector,
        'categorySelector': value.categorySelector,
        'descriptionSelector': value.descriptionSelector,
        'id': value.id,
        'imageUrlSelector': value.imageUrlSelector,
        'locationId': value.locationId,
        'priceSelector': value.priceSelector,
        'productIdSelector': value.productIdSelector,
        'projectId': value.projectId,
        'skuSelector': value.skuSelector,
        'titleSelector': value.titleSelector,
        'uniqueField': ApiProductTaggerUniqueFieldToJSON(value.uniqueField),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'useLinkedData': value.useLinkedData,
    };
}
